class ExtrasFormController {
    constructor(currentPropertyService, $state, extrasService, messageService, treatmentsService, integrationApiService) {
        this.currentProperty = currentPropertyService;
        this.$state = $state;
        this.extrasService = extrasService;
        this.messageService = messageService;
        this.treatmentsService = treatmentsService;
        this.integrationApiService = integrationApiService;
    }

    $onInit () {
        this.property = this.currentProperty.get();
        this.extra = this.extra || {};
        this.extra.options = this.extra.options || [];
        this.extra.property_id = this.property.id;

        this.treatmentsService.findAll(-1).then(response => {
            this.treatments = response;
        });

        this.hasIntegration = !!this.property.integration;
        if (this.hasIntegration) {
            this.integrationApiService.integrationExtraCollect(this.property.id).then(response => {
                this.importedExtras = response;
            });
        }
    }

    onSave () {
        return this.extrasService.save(this.extra)
            .then(response => {
                if (this.extra.id) {
                    this.messageService.success(`The extra <strong>${this.extra.name}</strong> was successfully updated!`, [`app.admin.extra-edit({ 'extra' : ${this.extra.id}})`, `Extra`]);
                    this.$state.go('app.admin.extras');
                } else {
                    this.messageService.success(`The extra <strong>${this.extra.name}</strong> was successfully created.`);
                    this.$state.go('app.admin.extra-edit', { extra: response.id, tab: 'visibility' });
                }
            })
            .catch((error) => {
                error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);

                let sourceElement = Object.keys(error.data);
                let verb = 'created';
                if (this.extra.id) {
                    verb = 'updated';
                }

                if (sourceElement.length > 0) {

                    let errors = '';
                    for (let element of sourceElement) {
                        errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
                    }
                    this.messageService.failure(`The extra <strong>${this.extra.name}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
                } else {
                    this.messageService.failure(`The extra <strong>${this.extra.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
                }
                this.messageService.push();
            });
    }

    addOption () {
        this.extra.options.push({});
    }
}

ExtrasFormController.$inject = ['currentPropertyService', '$state', 'extrasService', 'messageService', 'treatmentsService', 'integrationApiService'];

export default ExtrasFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/extras.form.controller.js